export default __webpack_public_path__ + "static/media/profile.3e080383.jfif";